import { resolveComponent as _resolveComponent, createVNode as _createVNode, withModifiers as _withModifiers, normalizeClass as _normalizeClass, normalizeStyle as _normalizeStyle, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, Transition as _Transition, withCtx as _withCtx, createBlock as _createBlock } from "vue"

const _hoisted_1 = ["href"]

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_base_icon = _resolveComponent("base-icon")

  return (_openBlock(), _createBlock(_Transition, { name: "gfu-fade" }, {
    default: _withCtx(() => [
      ($options.isVisible)
        ? (_openBlock(), _createElementBlock("a", {
            key: 0,
            href: `#${$props.elementId}`,
            class: _normalizeClass(['gfu-project-return-to-navigation','gfu-project-return-to-navigation--right', {'gfu-project-return-to-navigation--expanded' : $props.isBarExpanded }]),
            style: _normalizeStyle($options.elementStyle),
            onClick: _cache[0] || (_cache[0] = _withModifiers((...args) => ($options.onClick && $options.onClick(...args)), ["prevent"]))
          }, [
            _createVNode(_component_base_icon, { name: "chevron-up" })
          ], 14 /* CLASS, STYLE, PROPS */, _hoisted_1))
        : _createCommentVNode("v-if", true)
    ]),
    _: 1 /* STABLE */
  }))
}